import { parsePhoneNumber } from './parsePhoneNumber';

/**
 * Eg: "+12133734253"
 */
export function formatE164PhoneNumber(input: string) {
	try {
		return parsePhoneNumber(input).format('E.164');
	} catch (error) {
		return input;
	}
}
